/* Eduplay product page helpers.
   Package picker: Dawn re-renders the price and picker only after a server round trip
   (~0.3s) when a package is picked. To make picking feel instant, on tap we immediately:
   1. show the picked package's price in the main price (read from the picked box itself),
   2. update the delivery line from that same price,
   3. update the mobile sticky bar,
   4. slide the main gallery once to the matching photo (radio's data-pkg-media;
      only the gallery slides, the page never scrolls),
   5. keep Add to cart / Buy buttons looking normal while Dawn briefly disables them.
   When Dawn's update lands (it re-enables the buttons / swaps the picker) we re-sync once;
   the values are the same, so nothing jumps.
   Gallery: photos don't fade in on swipe, and all gallery photos load once the page is idle.
   Sticky bar (phones): shows only after scrolling past the real Add to cart button; the
   WhatsApp button appears with it, sitting just above it.
   Delivery texts and threshold come from #pkg-tax-cfg in product-variant-picker.liquid. */
(function () {
  if (window.__eduplayPkg) return;
  window.__eduplayPkg = true;

  var WA = '.wa-widget-button-container, .wa-preview-corner-button-container';

  function parsePrice(text) {
    var n = parseFloat(String(text || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  function addStyle(css) {
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function init() {
    var info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info) return;

    addStyle(
      /* gallery: no fade-in per slide (it replays on every swipe) */
      'media-gallery .product__media-item.scroll-trigger{animation:none!important;opacity:1!important;transform:none!important}' +
      /* while a package switch is loading, Dawn disables the buy buttons: don't show it */
      '.pkg-switching .product-form__submit[disabled],.pkg-switching .pkg-bar__btn[disabled]{opacity:1!important;cursor:pointer}' +
      '.pkg-switching .shopify-payment-button{opacity:1!important}' +
      /* no press-shrink on package boxes (Dawn redraws them mid-press) */
      '.pkg8__row:active{transform:none!important}'
    );

    warmGallery(info);

    var cfg = null;
    try { var c = document.getElementById('pkg-tax-cfg'); cfg = c && JSON.parse(c.textContent); } catch (e) {}

    /* ----- helpers bound to this product ----- */
    function visibleSelects() {
      var all = info.querySelectorAll('variant-selects');
      for (var i = 0; i < all.length; i++) if (all[i].style.display !== 'none') return all[i];
      return all[0] || null;
    }
    function checkedInput() {
      var vs = visibleSelects();
      return vs ? vs.querySelector('.pkg__input:checked') : null;
    }
    function boxFor(input) {
      return input ? info.querySelector('label[for="' + input.id + '"]') : null;
    }
    function submitBtn() {
      return info.querySelector('[id^="ProductSubmitButton-"]');
    }
    function pagePriceEl() {
      return info.querySelector('[id^="price-"] .price-item--last') || info.querySelector('[id^="price-"] .price-item');
    }
    // Price of the picked package (text as shown in its box), else the page price.
    function currentPriceText() {
      var box = boxFor(checkedInput());
      var p = box && box.querySelector('.pkg8__price');
      if (p) return p.textContent.trim();
      var el = pagePriceEl();
      return el ? el.textContent.trim() : '';
    }

    /* ----- 1. instant main price ----- */
    function setPagePrice(text) {
      if (!text) return;
      var wrap = info.querySelector('[id^="price-"] .price');
      if (!wrap || wrap.classList.contains('price--on-sale')) return; // leave sale layouts to Dawn
      wrap.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--last').forEach(function (el) {
        if (el.textContent.trim() !== text) el.textContent = text;
      });
    }

    /* ----- 2. delivery line ----- */
    function updateDelivery() {
      var tax = info.querySelector('.product__tax');
      if (!tax) return;
      var n = parsePrice(currentPriceText());
      if (cfg && n !== null) {
        var html = n >= cfg.min ? cfg.free : cfg.under;
        if (tax.innerHTML !== html) tax.innerHTML = html;
      }
      tax.classList.add('pkg-tax');
    }

    /* ----- 4. gallery ----- */
    function showMedia(mediaId) {
      if (!mediaId) return;
      var gallery = info.querySelector('media-gallery');
      if (!gallery) return;
      var item = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!item || !item.parentElement || item.classList.contains('is-active')) return;
      gallery.querySelectorAll('[data-media-id]').forEach(function (el) {
        el.classList.toggle('is-active', el === item);
      });
      item.parentElement.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      var thumb = gallery.querySelector('[data-target="' + mediaId + '"]');
      if (thumb && typeof gallery.setActiveThumbnail === 'function') {
        try { gallery.setActiveThumbnail(thumb); } catch (e) {}
      }
    }

    /* ----- 3. mobile sticky bar ----- */
    var bar = initBar(info, checkedInput, boxFor, currentPriceText);

    function syncAll() {
      updateDelivery();
      if (bar) bar.refresh();
    }

    /* ----- 5. buy buttons stay calm while switching ----- */
    var switching = false;
    var switchTimer;
    function endSwitch() {
      if (!switching) return;
      switching = false;
      clearTimeout(switchTimer);
      info.classList.remove('pkg-switching');
      syncAll();
    }
    // Dawn's update has landed once the Add to cart button is enabled again (or the picker was
    // swapped while it stays disabled, e.g. a sold-out package).
    var landed = 0;
    new MutationObserver(function (muts) {
      if (!switching) return;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'childList') { for (var j = 0; j < m.addedNodes.length; j++) if (m.addedNodes[j].nodeName === 'VARIANT-SELECTS') landed++; }
      }
      var s = submitBtn();
      if ((s && !s.hasAttribute('disabled')) || landed > 0) {
        cancelAnimationFrame(landed.raf);
        requestAnimationFrame(endSwitch);
      }
    }).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });

    // On tap: update everything right away from the picked box.
    info.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('pkg__input')) return;
      switching = true;
      landed = 0;
      info.classList.add('pkg-switching');
      clearTimeout(switchTimer);
      switchTimer = setTimeout(endSwitch, 2500); // safety net
      var box = boxFor(t);
      var p = box && box.querySelector('.pkg8__price');
      if (p) setPagePrice(p.textContent.trim());
      syncAll();
      showMedia(t.getAttribute('data-pkg-media'));
    });

    syncAll();
  }

  // Load every gallery photo once the page is idle, so swiping never shows a blank slide.
  function warmGallery(info) {
    var go = function () {
      info.querySelectorAll('media-gallery img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    };
    function schedule() {
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 1200);
    }
    if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule);
  }

  function initBar(info, checkedInput, boxFor, currentPriceText) {
    var submit = info.querySelector('[id^="ProductSubmitButton-"]');
    if (!submit) return null;

    var bar = document.createElement('div');
    bar.className = 'pkg-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="pkg-bar__info"><span class="pkg-bar__name"></span><span class="pkg-bar__price"></span></div>' +
      '<button type="button" class="pkg-bar__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    document.body.classList.add('pkg-page');
    var nameEl = bar.querySelector('.pkg-bar__name');
    var priceEl = bar.querySelector('.pkg-bar__price');
    var btn = bar.querySelector('.pkg-bar__btn');

    function liveSubmit() {
      return info.querySelector('[id^="ProductSubmitButton-"]') || submit;
    }

    function refresh() {
      var box = boxFor(checkedInput());
      var label = box && box.querySelector('[data-pkg-name]');
      var title = info.querySelector('.product__title h1, .product__title');
      var name = label ? label.textContent.trim() : (title ? title.textContent.trim() : '');
      if (nameEl.textContent !== name) nameEl.textContent = name;
      var price = currentPriceText();
      if (priceEl.textContent !== price) priceEl.textContent = price;
      var s = liveSubmit();
      var txt = s.querySelector('span');
      var label2 = (txt ? txt.textContent : s.textContent).trim();
      if (label2 && btn.textContent !== label2) btn.textContent = label2;
      btn.disabled = s.hasAttribute('disabled') && !info.classList.contains('pkg-switching');
    }

    btn.addEventListener('click', function () {
      var s = liveSubmit();
      if (!s.hasAttribute('disabled')) s.click();
    });

    // WhatsApp chat button on phones (Moose WhatsApp; class names differ by launcher style):
    // hidden at the top of the product page, appears together with the sticky bar and sits just
    // above it. Uses the separate `translate` property so the app's own transform isn't overwritten.
    // The glide/fade timing and the "no pulse" rules live in snippets/eduplay-enhancements.liquid.
    addStyle(
      '@media screen and (max-width:749px){' +
        'body.pkg-page:not(.pkg-bar-on) :is(' + WA + '){opacity:0!important;pointer-events:none!important;translate:0 1.2rem!important;}' +
        'body.pkg-bar-on :is(' + WA + '){translate:0 calc(-7rem - env(safe-area-inset-bottom,0px))!important;}' +
      '}'
    );

    function setOn(on) {
      if (bar.classList.contains('is-on') === on) return;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('pkg-bar-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    // Show only once the real Add to cart button has been scrolled past (it's above the screen),
    // not while it's still further down the page.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        setOn(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(submit);
    }

    refresh();
    return { refresh: refresh };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
